export default "__VITE_ASSET__DE4l7Wcu__"